import dayjs from 'dayjs';
import { dateFormat } from '@/constants/date';

class DateService {
  public static checkIsValidDate(value: any): boolean {
    return dayjs(value).isValid();
  }

  public static formatIsoDate(value: string, format = dateFormat) {
    return dayjs(value).format(format);
  }

  public static isIsoDateString(value: string): boolean {
    if (typeof value !== 'string') return false;

    const parsed = dayjs.utc(value, undefined, true);
    return (
      parsed.isValid() && parsed.format('YYYY-MM-DDTHH:mm:ss') === value.slice(0, value.includes('Z') ? -1 : undefined)
    );
  }
}

export default DateService;
